import initAppFrameServices from './appframe';
import initBaseServices, { services } from './base';

export const initServices = async () => {
  initBaseServices();
  await initAppFrameServices();
};

export const resetServices = async () => {
  Object.keys(services).forEach((key) => delete services[key]);
  await initServices();
};

export default services;
